"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const Common_1 = require("./Common");
const TGLabelWrapper_1 = __importDefault(require("./TGLabelWrapper"));
const useDataProvider_1 = require("../../hooks/useDataProvider");
const TGRadioField = (props) => {
    const { options, label, dataProvider, error, warning, helperText, required, readOnly, info } = props, radioGroupProps = __rest(props, ["options", "label", "dataProvider", "error", "warning", "helperText", "required", "readOnly", "info"]);
    const { loading, options: dataProviderOptions, computeOptions } = useDataProvider_1.useDataProvider({
        dataProvider,
        options,
    });
    const [tooltip, setTooltip] = react_1.useState(false);
    react_1.useEffect(() => {
        computeOptions(undefined, true);
    }, [computeOptions]);
    const classes = Common_1.useStyles();
    return (react_1.default.createElement(core_1.FormControl, { component: "fieldset", className: classes.formElementWrapper, error: error, 
        // We want the Tooltip to be triggered on field hovering, but positionned relative to the label
        onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) },
        react_1.default.createElement(core_1.FormLabel, { component: "legend", className: clsx_1.default(warning && classes.warningText) },
            react_1.default.createElement(TGLabelWrapper_1.default, { required: required, readOnly: readOnly, label: label, info: info, tooltip: tooltip })),
        !loading && dataProviderOptions && (react_1.default.createElement(core_1.RadioGroup, Object.assign({}, radioGroupProps, { style: { marginTop: 10 } }), dataProviderOptions.map((option, index) => (react_1.default.createElement(core_1.FormControlLabel, { key: index, value: option.value, control: react_1.default.createElement(core_1.Radio, null), label: option.label, disabled: readOnly, style: { height: 34 } }))))),
        helperText && (react_1.default.createElement(core_1.FormHelperText, { className: clsx_1.default(warning && classes.warningText) }, helperText))));
};
exports.default = TGRadioField;
//# sourceMappingURL=TGRadioField.js.map